<template>
  <PageWrapper v-once>
    <container>
      <SectionHeader>
        <h1>
          WHAT ARE BOHEMIA ACCOUNTS?
        </h1>
      </SectionHeader>
      <Divider size="2em" />
      <grid :rwd="{ compact: 'stack' }">
        <grid-item size="1/3" :rwd="{ tablet: '1/1' }">
          <SectionWrapper class="whiteframe shadowframe">
            <Icon type="account" :size="8" color="#6BA539" />
            <p>
              <b>One Account</b><br />Use a single login across recent and
              upcoming games and services
            </p>
          </SectionWrapper>
        </grid-item>
        <grid-item size="1/3" :rwd="{ tablet: '1/1' }">
          <SectionWrapper class="whiteframe shadowframe">
            <Icon type="connect" :size="8" color="#6BA539" />
            <p>
              <b>Connect</b><br />Get in touch with other players and share your
              experiences on the forums
            </p>
          </SectionWrapper>
        </grid-item>
        <grid-item size="1/3" :rwd="{ tablet: '1/1' }">
          <SectionWrapper class="whiteframe shadowframe">
            <Icon type="store" :size="8" color="#6BA539" />
            <p>
              <b>Store</b><br />Support your favorite developer by purchasing
              straight from the source
            </p>
          </SectionWrapper>
        </grid-item>
      </grid>

      <Divider />

      <DividerSeparator>
        <DecoratedButton
          name="register"
          type="link"
          :route="{ name: pages.AUTH_REGISTER }"
          class="wide short dark-blue"
          fontSize=".8em"
        >
          CREATE AN ACCOUNT
        </DecoratedButton>
      </DividerSeparator>

      <p>
        Get the most out of your favorite games and sign up for a free
        cross-platform Bohemia Account.
        <br />
        Your Bohemia Account opens the door to <b>meaningful interaction</b>
        <br />
        and <b>a more connected gaming experience</b>.
      </p>
    </container>
  </PageWrapper>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "homepage",
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      isLoggedIn: "isLoggedIn"
    })
  },
  watch: {
    isLoggedIn: ["redirect"]
  },
  methods: {
    ...mapActions("user", {
      redirectAfterLogin: "redirectAfterLogin"
    }),
    redirect() {
      if (this.isLoggedIn) {
        this.redirectAfterLogin();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
